import script from "./SnapAccessCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapAccessCard.vue?vue&type=script&setup=true&lang=js"

import "./SnapAccessCard.vue?vue&type=style&index=0&id=9512ff06&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9512ff06"]])

export default __exports__